// Datei: frontend/src/pages/AdminLogin.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        try {
            const res = await fetch('/api/admin/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            })

            const data = await res.json();
            if (!res.ok) throw new Error(data.message || 'Login fehlgeschlagen');
            localStorage.setItem('adminToken', data.token);
            navigate('/admin/dashboard');
        } catch (err: any) {
            setError(err.message);
        }
    };

    return (
        <div className="p-8 max-w-md mx-auto">
            <h1 className="text-2xl font-bold mb-4">Admin Login</h1>
            <form onSubmit={handleLogin} className="space-y-4">
                <input type="text" placeholder="Benutzername" value={username} onChange={(e) => setUsername(e.target.value)} className="w-full border px-3 py-2" />
                <input type="password" placeholder="Passwort" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border px-3 py-2" />
                {error && <div className="text-red-500 text-sm">{error}</div>}
                <button type="submit" className="bg-blue-600 text-white px-4 py-2">Login</button>
            </form>
        </div>
    );
};

export default AdminLogin;
